import { useI18n } from "@/i18n";
import { Reveal } from "./motion";

export const Approach = () => {
  const { t } = useI18n();
  return (
    <section
      id="approche"
      data-testid="approach-section"
      className="mx-auto max-w-[1400px] px-6 py-28 md:px-10 md:py-40"
    >
      <div className="grid grid-cols-1 gap-12 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <Reveal>
            <span className="font-body text-[11px] uppercase tracking-[0.28em] text-[#9e8d7b]">
              {t.approach.label}
            </span>
            <h2 className="mt-6 font-display text-4xl leading-[1.05] tracking-tight text-[#1c1c1a] md:text-5xl">
              {t.approach.standfirst}
            </h2>
            <p className="mt-8 max-w-sm font-body text-base leading-relaxed text-[#5c5c57]">
              {t.approach.body}
            </p>
          </Reveal>
        </div>

        <div className="lg:col-span-8 lg:pl-10">
          <div className="border-t border-[#dcdcd6]">
            {t.chapters.map((c, i) => (
              <Reveal key={c.n} delay={i * 0.08}>
                <div className="grid grid-cols-1 gap-4 border-b border-[#dcdcd6] py-9 md:grid-cols-12 md:items-baseline md:gap-8">
                  <span className="font-display text-2xl text-[#9e8d7b] md:col-span-2">{c.n}</span>
                  <h3 className="font-display text-3xl tracking-tight text-[#1c1c1a] md:col-span-4">{c.title}</h3>
                  <p className="font-body text-base leading-relaxed text-[#5c5c57] md:col-span-6">{c.body}</p>
                </div>
              </Reveal>
            ))}
          </div>

          <div className="mt-14 grid grid-cols-2 gap-8 sm:grid-cols-3 md:grid-cols-5">
            {t.stats.map((s, i) => (
              <Reveal key={i} delay={i * 0.08} className={i === t.stats.length - 1 && t.stats.length % 2 === 1 ? "col-span-2 sm:col-span-1" : ""}>
                <div data-testid={`stat-${i}`} className="text-center">
                  <div className="whitespace-nowrap font-display text-3xl tracking-tight text-[#1c1c1a] md:text-4xl">{s.value}</div>
                  <div className="mt-2 font-body text-[11px] uppercase tracking-[0.18em] text-[#5c5c57]">{s.label}</div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
